// src/components/Login/LogIn.jsx

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Navigate, Link as RouterLink } from 'react-router-dom';
import {
  Box,
  FormControl,
  FormLabel,
  Input,
  VStack,
  Button,
  Text,
  Link,
  useToast,
  InputGroup,
  InputRightElement,
  Divider,
} from "@chakra-ui/react";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { loginUser } from "../../Redux/Slice"; // Quitar handleGoogleCallback de aquí
import BlackBox from "../../Landing/InfoTopBox";
import ResponsiveNav from "../../Landing/ResponsiveNav";
import GoogleAuthButton from "./GoogleButton"; // Importa el botón de Google

export default function LoginCard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, status, error, token } = useSelector((state) => state); // Añadir error al selector
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const toast = useToast();

  // ***** SE ELIMINA EL useEffect QUE BUSCABA EL 'code' *****
  // El manejo del callback de Google se hará en GoogleCallback.jsx

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // El loginUser thunk ahora debería devolver el usuario completo
      const loggedInUser = await dispatch(loginUser({ email, password })).unwrap();
      showSuccessToast("Inicio de sesión exitoso");
      // Navegar basado en si los datos personales están completos
      checkUserInfoAndNavigate(loggedInUser);
    } catch (err) {
       // Usar el error del estado de Redux si está disponible, o el error del catch
       const errorMessage = err || error || "Ocurrió un error"; // error viene del useSelector
      showErrorToast("Error en el inicio de sesión", errorMessage);
    }
  };

  // Función para decidir a dónde navegar después del login
  const checkUserInfoAndNavigate = (loggedInUser) => {
    if (!loggedInUser) return; // Seguridad
    // Asumiendo que los campos necesarios están en el objeto user
    if (!loggedInUser.username || !loggedInUser.email || !loggedInUser.direccion || !loggedInUser.telefono) {
       navigate('/PersonalData'); // Redirige a completar datos
    } else {
       navigate('/'); // Redirige al inicio
    }
  };


  const showSuccessToast = (title) => {
    toast({
      title,
      status: "success",
      duration: 3000,
      isClosable: true,
      position: "top",
      containerStyle: { marginBottom: "80px" },
    });
  };

  const showErrorToast = (title, description) => {
    toast({
      title,
      description: description || "Ocurrió un error",
      status: "error",
      duration: 3000,
      isClosable: true,
      position: "top",
      containerStyle: { marginBottom: "80px" },
    });
  };

  // Si el usuario ya está logueado (por ejemplo, por carga inicial desde localStorage)
  if (user && token) { // Verificar token también puede ser útil
    return <Navigate to="/" />;
  }

  return (
    <Box style={{marginTop:"80px", paddingBottom:"100px"}}>
      <ResponsiveNav />
      <VStack spacing={6} align="stretch" padding={"1rem"}>
        <BlackBox
          showBackButton={true}
          info={"Inicia sesión para disfrutar al máximo el servicio."}
          titulo={"Iniciar Sesión"}
        />
        <form onSubmit={handleSubmit}>
          <VStack spacing={4} align="stretch" maxW="500px" margin="auto">
            <FormControl id="email-login" isRequired> {/* Cambiar ID si es necesario */}
              <FormLabel>Dirección de correo electrónico</FormLabel>
              <Input
                style={styles.Input}
                type="email"
                placeholder="nombre@ejemplo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </FormControl>
            <FormControl id="password-login" isRequired> {/* Cambiar ID si es necesario */}
              <FormLabel>Contraseña</FormLabel>
              <InputGroup>
                <Input
                  style={styles.Input}
                  type={showPassword ? "text" : "password"}
                  placeholder="Tu contraseña"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                   autoComplete="current-password"
                />
                <InputRightElement width="4.5rem">
                  <Button
                    h="1.75rem"
                    size="sm"
                    bg={"none"}
                    _hover={{ bg: 'transparent' }} // Evitar cambio de fondo en hover
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                  >
                    {showPassword ? <ViewOffIcon /> : <ViewIcon />}
                  </Button>
                </InputRightElement>
              </InputGroup>
            </FormControl>
            <Button
              type="submit"
              colorScheme="red"
              size="lg"
              width="full"
              isLoading={status === "loading"}
              style={styles.button}
            >
              Acceder
            </Button>
          </VStack>
        </form>
        {/* Separador y botón de Google */}
        <VStack spacing={4} maxW="500px" margin="auto" width="full">
           <Divider />
           {/* <Text fontSize="sm" color="gray.600">O inicia sesión con</Text>
           <GoogleAuthButton /> */}
        </VStack>
        <Divider />
        <Text align="center">
          ¿No tienes cuenta?{" "}
          <Link as={RouterLink} to="/signup" color="red.500" id="redirRegistroBoton">
            Regístrate
          </Link>
        </Text>
      </VStack>
    </Box>
  );
}

// Mantener estilos
const styles = {
  Input: {
    borderRadius: "24px",
    backgroundColor: "#F2F2F2",
    width: "100%",
  },
  button: {
    borderRadius: "24px",
    backgroundColor: "#CA0017",
    color: "white",
    width: "100%",
    padding: "12px 24px",
  },
};